import { useState } from "react";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import Accordion from "../../../../components/acordion/accordion";
import NationalDescription from "../../../../components/national-description/national-description";
import "../../nationals/shared-css/national-global-styles.css";
import "./specialized-service-layout.css";

function parseQuillContent(apiString, fallbackJsonString) {
  try {
    if (apiString) {
      return JSON.parse(apiString);
    }
    return JSON.parse(fallbackJsonString || "{}");
  } catch {
    return {};
  }
}

function SpecializedServiceLayout({
  metaTitle,
  metaDescription,
  imgBackground,
  pageTitle,
  descriptionApiString,
  descriptionFallbackJson,
  contactSales,
  contactProductID,
  quoteBtn,
  quoteProductID,
  prepareChargeTitle,
  accordionConfigs = [],
  moreInfoLeft,
  moreInfoRight,
}) {
  const [openAccordion, setOpenAccordion] = useState(null);
  const description = parseQuillContent(
    descriptionApiString,
    descriptionFallbackJson
  );

  const leftItems = Array.isArray(moreInfoLeft?.items) ? moreInfoLeft.items : [];
  const rightItems = Array.isArray(moreInfoRight?.items)
    ? moreInfoRight.items
    : [];

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      <ImageHeader imgBackground={imgBackground} />
      <div className="info-national-content">
        <NationalDescription
          title={pageTitle}
          description={description}
          quoteBtn={quoteBtn}
          quoteProductID={quoteProductID}
          contactSales={contactSales}
          contactProductID={contactProductID}
        />
        {accordionConfigs.length > 0 && (
          <div className="accordion-content-main">
            <div className="title">
              <h3>{prepareChargeTitle}</h3>
            </div>
            <div className="accordion-padd">
              {accordionConfigs.map((cfg) => (
                <Accordion
                  key={cfg.id}
                  id={cfg.id}
                  isOpen={openAccordion === cfg.id}
                  onToggle={setOpenAccordion}
                  title={cfg.title}
                  content={parseQuillContent(
                    cfg.apiContent,
                    cfg.fallbackContentJson
                  )}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default SpecializedServiceLayout;
